import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import api from '../services/api';

// Mi recorrido (29-oct-2026): lo comparten el mapa del día de "Hoy" y la ventana "Mi recorrido" del técnico.
// Desde dónde arranca: depósito, Estación Lanús, otra guardada o donde está (GPS). Se recuerda en este celu;
// sin elegir, Lucas sale del depósito y los demás de la base.
export function ubicacion() {
    return new Promise((ok) => {
        if (!navigator.geolocation) { ok(null); return; }
        navigator.geolocation.getCurrentPosition(p => ok({ lat: p.coords.latitude, lng: p.coords.longitude }), () => ok(null),
            { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 });
    });
}

export default function useMiRecorrido(tecnicoId, recargarKey = 0) {
    const [d, setD] = useState(null);
    const [cargando, setCargando] = useState(true);
    const clave = `salida_recorrido_${tecnicoId}`;
    const [salida, setSalida] = useState(() => { try { return localStorage.getItem(clave) || null; } catch { return null; } });

    const cargar = useCallback(async (s = salida) => {
        if (!tecnicoId) return;
        setCargando(true);
        try {
            const pos = await ubicacion();
            const r = await api.get(`/ordenes/mi-recorrido/${tecnicoId}`, { params: { ...(pos || {}), ...(s ? { salida: s } : {}) } });
            setD(r.data);
        } catch { toast.error('No se pudo armar el recorrido'); }
        finally { setCargando(false); }
    }, [tecnicoId, salida]);
    useEffect(() => { cargar(); }, [cargar, recargarKey]);
    const elegirSalida = (id) => {
        if (id === salida) { cargar(id); return; }
        setSalida(id);
        try { if (id === 'GPS') localStorage.removeItem(clave); else localStorage.setItem(clave, id); } catch { /* */ }
    };
    return { d, cargando, salida, cargar, elegirSalida };
}

const PROPIA = '#7C3AED';
export const COLOR_PROPIA = PROPIA;

/** Puntos y línea del mapa: salida, paradas numeradas (lo propio en violeta) y, si se pide, lo que hay para confirmar. */
export function mapaDe(d, { conPropuestas = false } = {}) {
    if (!d) return { puntos: [], linea: null, faltan: [], conPos: [], numero: new Map() };
    const faltan = d.paradas.filter(p => !p.hecha);
    const conPos = faltan.filter(p => p.lat != null);
    const numero = new Map(faltan.map((p, i) => [p.id, i + 1]));
    const puntos = [
        { id: 'origen', lat: d.origen.lat, lng: d.origen.lng, color: '#2563EB', etiqueta: '•', titulo: d.deDonde === 'GPS' ? 'Estás acá' : `Salís de ${d.origen.nombre}`, tituloFijo: true },
        ...d.paradas.filter(p => p.lat != null).map(p => ({
            id: p.id, lat: p.lat, lng: p.lng, apagado: p.hecha,
            color: p.hecha ? '#9CA3AF' : p.tipo === 'PROPIA' ? PROPIA : '#C9341F',
            etiqueta: p.hecha ? undefined : String(numero.get(p.id)),
            titulo: `${p.nombre}${p.llegada ? ` · llega ${p.llegada}` : ''}`,
        })),
        ...(conPropuestas ? (d.paraConfirmar || []).filter(p => p.lat != null).map(p => ({
            id: `p${p.ordenId}`, ordenId: p.ordenId, lat: p.lat, lng: p.lng, color: '#D48800', hueco: true, titulo: `Para confirmar · ${p.nombre}`,
        })) : []),
    ];
    const linea = [[d.origen.lat, d.origen.lng], ...conPos.map(p => [p.lat, p.lng])];
    return { puntos, linea, faltan, conPos, numero };
}
